import { useProfilePathways } from '../../../hooks';
import React from 'react';
import { PathwaysBox } from '../../../components';
import './PathwaysViewContent.css';

interface PathwaysViewContentProps {
  username: string;
}

export const PathwaysViewContent: React.FC<PathwaysViewContentProps> = ({
  username,
}) => {
  const [userPathways, userPathwaysLoaded] = useProfilePathways(username);

  return (
    <span>
      <div
        className="ov_panel active"
        data-name="p"
        style={{ marginTop: '20px' }}
      >
        <div className="br_cont">
          <div className="div-block-483">
            <div className="text-block-278">My Pathways</div>
          </div>
          <div className="br_row">
            <PathwaysBox
              userPathways={userPathways}
              userPathwaysLoaded={userPathwaysLoaded}
            ></PathwaysBox>
          </div>
        </div>
      </div>
    </span>
  );
};
